<template>
	<div
		class="line-item__row"
		:class="{ 'line-item__row--total': total }">
		<span>{{ label }}</span>
		<span class="line-item__value line-item__value--strong">
			{{ value }}
			<span
				v-if="unit"
				:class="{ 'line-item__eur-unit': unit === '€' }"
				>{{ unit }}</span
			>
		</span>
	</div>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		label: string
		value: string | number
		unit: 'tok' | '€' | null
		total?: boolean
	}>(),
	{
		total: false,
	},
)
</script>

<style lang="scss">
.line-item__row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 0;
	font-size: 15px;

	&--total {
		font-weight: 800;
	}

	.line-item__value {
		font-weight: 700;

		&:has(.line-item__eur-unit) {
			margin-right: 14px;
		}

		.line-item__tokens-unit {
			font-size: 10px;
		}
	}
}
</style>
